import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { navigateToCompanyWorkspace } from "@/shared/utils/collaborationNavigation.util";

/** Sends logged-in company profile URLs to the collaboration workspace (match or preview). */
export default function LoggedInCompanyWorkspaceRedirect() {
  const { id: companyId } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!companyId) {
      navigate("/my-discovery", { replace: true });
      return;
    }
    void navigateToCompanyWorkspace(navigate, companyId, {
      replace: true,
      state: location.state,
    });
  }, [companyId, navigate, location.state]);

  return (
    <Center mih="50vh">
      <Loader size="lg" />
    </Center>
  );
}
